import { PictureOrVideo } from 'components/atoms';
import { Hero } from 'components/organisms';
import React, {FC} from 'react';

type TStandardHeroMobileProps = {
    isDesktop: boolean;
    width: number;
    mobileSrc: string;
    mobileAlt: string;
    HeroSectionVideoAutoplay: boolean;
    HeroSectionVideoLoop: boolean;
}

export const StandardHeroMobile: FC<TStandardHeroMobileProps> = ({
    isDesktop,
    width,
    mobileSrc,
    mobileAlt,
    HeroSectionVideoAutoplay,
    HeroSectionVideoLoop
}) => {
    return (
        <Hero isDesktop={isDesktop} width={width}>
          <PictureOrVideo
            src={mobileSrc}
            alt={mobileAlt}
            autoPlay={HeroSectionVideoAutoplay}
            loop={HeroSectionVideoLoop}
          />
      </Hero>
    )
}
